module.exports = __webpack_public_path__ + "public/SiteIcons/filterAllUparrow.svg?288a6c7e";